import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-k-small', 'LetterKSmall', [["path",{"d":"M10.5 8v8"}],["path",{"d":"M14.5 8l-3 4l3 4"}],["path",{"d":"M10.5 12h1"}]]);